module.exports = __webpack_public_path__ + "static/google-play-store-7ff1d6cdc55119ee4af31d7692da949b.svg";